import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalsComponent } from "./modals.component";
import { ActionButtonComponent } from './action-button/action-button.component';
import { ModalsService } from "./modals.service";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import {
    NgbDatepickerModule,
    NgbTimepickerModule,
} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    imports: [
        CommonModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        FormsModule,
        TranslateModule
    ],
    declarations: [ModalsComponent, ActionButtonComponent],
    exports: [ModalsComponent, ActionButtonComponent],
    providers: [],
})
export class ModalsModule {
    static forRoot(): ModuleWithProviders<ModalsModule> {
        return {
            ngModule: ModalsModule,
            providers: [ModalsService],
        };
    }
}
